import { ReactSVG } from "react-svg";
import arrowLeft from "../../icon/ArrowLeft.svg";
import arrowRight from "../../icon/ArrowRight.svg";
import "../../style/table.scss";
import "../../style/typography.scss";
import "../../style/colors.scss";

/**
 * Pagination for the table component.
 * @param {object} props
 * @param {import("../../hooks/useTable").CustomReactTable} props.table `@tanstack/react-table` object. Use the custom `useTable` hook to create this object.
 */
function TablePagination({ table }) {
    if (!table.paginationOptions) {
        throw new Error(
            "TablePagination component requires the table to have paginationOptions set. The paginationOptions can be set when calling the useTable hook.",
        );
    }

    const { pageSizes, disableGoToPage, disableChangePageSize } = table.paginationOptions;

    /**
     *
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    function goToPageHandler(event) {
        const pageNumber = Number(event.target.value);

        table.setPageIndex(
            event.target.value
                ? pageNumber <= table.getPageCount()
                    ? pageNumber - 1
                    : table.getPageCount() - 1 // Display last page if user enters a page larger than the total page count
                : 0,
        );
    }

    return (
        <div style={{ display: "flex", justifyContent: "end", alignItems: "center", height: "26px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "28px" }}>
                <button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                    <ReactSVG src={arrowLeft} />
                </button>
                <span className="paragraph-5-semibold" style={{ color: "var(--colors-primary-slate-700)" }}>
                    Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
                </span>
                <button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                    <ReactSVG src={arrowRight} />
                </button>
            </div>

            {!disableGoToPage && ( // TODO Style this component according to the brand guide
                <>
                    <span>Go to page: </span>
                    <input
                        type="number"
                        min={1}
                        max={table.getPageCount()}
                        defaultValue={table.getState().pagination.pageIndex + 1}
                        onChange={goToPageHandler}
                        style={{ width: "150px" }}
                    />
                </>
            )}

            {!disableChangePageSize && ( // TODO Style this component according to the brand guide
                <select
                    value={table.getState().pagination.pageSize}
                    onChange={(e) => {
                        table.setPageSize(Number(e.target.value));
                    }}
                >
                    {pageSizes.map((pageSize) => (
                        <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
}

export default TablePagination;
